// extracted by mini-css-extract-plugin
export default {"modify_order_header":"BA","center":"CA","empty":"EA","pending":"FA","referralTitle":"GA","wrapper":"HA","title":"IA","tabs":"JA","tab":"KA","active":"LA","btn":"MA","rewards_table":"NA"};
    if(module.hot) {
      // 1715632475601
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  